import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import Question from "../../images/icons/question.svg";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Backdrop, CircularProgress, Grid } from "@material-ui/core";
import { Controller, useForm } from "react-hook-form";
import { uploadRefundFilesAsync } from "../../actions/refund-recommendation-actions";
import { REQUIRED_MESSAGE } from "../../constants";

const useStyles = makeStyles((theme) => ({
  root: {
    "&::-webkit-scrollbar": {
      width: 6,
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.1)`,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#BAE5F9",
      outline: `1px solid #ffffff`,
      borderRadius: 10,
    },
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  fileContainer: {
    cursor: "pointer",
    height: 120,
    width: 500,
    pointerEvents: "auto",
    border: "2px dashed rgba(206,206,206,0.33)",
    borderRadius: 10,
    textAlign: "center",
    paddingTop: 10,
  },
}));

const RefundUploadFilesModal = ({
  handleClose,
  open,
  setShowMessage,
  message,
  setMessage,
  id,
}) => {
  const classes = useStyles();
  setShowMessage(false);
  const [messageFiles, setMessageFiles] = useState("");
  const [messageCorrectFiles, setMessageCorrectFiles] = useState("");
  const [minDate, setMinDate] = useState(null);
  const [maxStartDate, setMaxStartDate] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const schema = yup.object().shape({
    initDate: yup
      .date()
      .typeError("Formato de fecha inválido")
      .nullable(true)
      .required(REQUIRED_MESSAGE),
    endDate: yup
      .date()
      .typeError("Formato de fecha inválido")
      .nullable()
      .notRequired(),
  });

  const { control, errors, getValues, setValue } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const adjuntarArchivos = (e) => {
    const docs = e.target.files;
    if (docs?.files?.length > 1) {
      setMessageFiles(`Se puede cargar máximo 1 archivo.`);
      setMessageCorrectFiles("");
    } else if (docs?.length > 0 && docs?.length < 2) {
      setMessageCorrectFiles(`Se ha agregado ${docs?.length} archivo`);
      setMessageFiles("");
      uploadDocuments(e.target.accept, e.target.files);
    }
  };

  const validateTypeSize = (accept, file) => {
    const fileSize = file.size / 1024 / 1024;
    if (file.type.toUpperCase() === "APPLICATION/PDF") {
      if (fileSize <= 5) {
        return { status: true, errorMessage: "" };
      } else {
        return {
          status: false,
          errorMessage: "El tamaño del archivo adjunto no es aceptado.",
        };
      }
    }
    let formats = accept.toUpperCase().split(",");
    if (formats.includes(file.type.toUpperCase())) {
      if (fileSize <= 2) {
        return { status: true, errorMessage: "" };
      } else {
        return {
          status: false,
          errorMessage: "El tamaño del archivo adjunto no es aceptado.",
        };
      }
    } else {
      return {
        status: false,
        errorMessage: "El tipo del archivo adjunto no es aceptado.",
      };
    }
  };

  const uploadDocuments = (accept, docs) => {
    for (let i = 0; i < docs.length; i++) {
      const { status, errorMessage } = validateTypeSize(accept, docs[i]);
      if (status) {
        const element = docs[i];
        convertToBase64(element);
      } else {
        setDocuments([]);
        setMessageFiles(errorMessage);
        setMessageCorrectFiles("");
      }
    }
    setMessage({ ...message, open: false });
  };

  function convertToBase64(file) {
    let base64 = new FileReader();
    base64.readAsDataURL(file);
    base64.onload = function () {
      const newBase64 = base64.result.toString().replace(/^data:(.*,)?/, "");
      saveReports(newBase64, file);
      return base64.result;
    };
    base64.onerror = function (error) {

      return;
    };
  }

  const saveReports = async (result, file) => {
    var fileExtension = file.name.split(".").pop().toUpperCase();

    const newFile = {
      initRefundDate: null,
      endRefundDate: null,
      data: result,
      format: fileExtension,
      name: file.name,
    };
    setDocuments((anterior) => [...anterior, newFile]);
  };

  const onChangeDate = (value) => {
    var data = getValues();
    if (data.endDate && data.endDate < value) {
      setMaxStartDate(value);
      setValue("endDate", null);
    }
    setMinDate(value);
    setMessageFiles(``);
  };

  const onChangeEndDate = (value) => {
    var data = getValues();
    if (data.initDate > value) {
      setValue("initDate", null);
    }
  };

  const onSaveFilesWithDates = (data, document) => {
    return {
      ...document,
      initRefundDate: data.initDate.toISOString(),
      endRefundDate: data.endDate ? data.endDate.toISOString() : null,
    };
  };

  const handleSaveFiles = async () => {
    var data = getValues();
    if (!data.initDate) {
      setMessageFiles(`La fecha de inicio es requerida.`);
      if (documents?.length < 1) {
        setMessageCorrectFiles("");
      }
      return;
    } else if (documents?.length < 1) {
      setMessageFiles(`Debe adjuntar 1 archivo.`);
      setMessageCorrectFiles("");
      return;
    }

    setIsLoading(true);
    const documentsToSend = [];
    documentsToSend.push(onSaveFilesWithDates(data, documents[0]));

    const response = await uploadRefundFilesAsync(id, documentsToSend);
    setIsLoading(false);

    if (response && (response?.status === 200 || response?.status === 201)) {
      handleClose();
      setShowMessage(true);
      setMessage({
        ...message,
        description: `Se ha cargado el archivo de forma exitosa.`,
        textButtonSubmit: "Volver",
        type: "SUCCESS",
        open: true,
      });
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.sattus !== 403
    ) {
      setMessageFiles(`No se han cargado los archivos, inténtelo nuevamente.`);
    } else {
      setMessageFiles(`No se han cargado los archivos, inténtelo nuevamente.`);
    }
  };

  return (
    <div>
      <Dialog
        PaperProps={{
          style: { borderRadius: 16, paddingLeft: 30, paddingRight: 30, paddingTop: 10,overflowY: "hidden", minHeight: "400px" },
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ color: "#7EBDCE" }}>
          <div style={{ textAlign: "center" }}>
            <img src={Question} alt="" style={{ width: "10%" }} />
            <p style={{margin: "0"}}>¿Desea adjuntar algún archivo?</p>
          </div>
        </DialogTitle>
        <DialogContent style={{ minHeight: "210px", overflowY: "hidden" }}>
          <div>
            <form
              className={classes.form}
              autoComplete="off"
              style={{ marginBottom: "10px" }}
            >
              <Grid container spacing={1}>
                <Grid item xs={12} md={6} lg={6}>
                  <MuiPickersUtilsProvider
                    locale={deLocale}
                    utils={DateFnsUtils}
                  >
                    <Controller
                      as={
                        <KeyboardDatePicker
                          fullWidth
                          inputVariant="outlined"
                          variant="inline"
                          format="dd/MM/yyyy"
                          dateFormat="DD/MM/YYYY"
                          label="Fecha de inicio *"
                          InputLabelProps={{ shrink: true }}
                          onAccept={onChangeDate}
                          error={
                            !!errors.hasOwnProperty("initDate") &&
                            errors["initDate"].message
                          }
                          helperText={
                            errors.hasOwnProperty("initDate") &&
                            errors["initDate"].message
                          }
                        />
                      }
                      control={control}
                      name="initDate"
                      defaultValue={null}
                      placeholder="Desde"
                      size="small"
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <MuiPickersUtilsProvider
                    locale={deLocale}
                    utils={DateFnsUtils}
                  >
                    <Controller
                      as={
                        <KeyboardDatePicker
                          fullWidth
                          inputVariant="outlined"
                          variant="inline"
                          format="dd/MM/yyyy"
                          dateFormat="DD/MM/YYYY"
                          label="Fecha final"
                          InputLabelProps={{ shrink: true }}
                          onAccept={onChangeEndDate}
                          error={
                            !!errors.hasOwnProperty("endDate") &&
                            errors["endDate"].message
                          }
                          helperText={
                            errors.hasOwnProperty("endDate") &&
                            errors["endDate"].message
                          }
                          minDate={minDate ? minDate : "01.01.2020"}
                        />
                      }
                      control={control}
                      name="endDate"
                      defaultValue={null}
                      placeholder="Hasta"
                      size="small"
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>
            </form>

            <input
              accept={[
                "application/pdf",
                "image/jpg",
                "image/png",
                "image/jpeg",
              ]}
              type="file"
              onChange={(e) => adjuntarArchivos(e)}
              id="icon-button-file-exam"
              style={{
                display: "none",
                pointerEvents: "auto",
                marginTop: "20px",
              }}
            />
            <label htmlFor="icon-button-file-exam">
              <div className={classes.fileContainer}>
                <CloudUploadIcon color="disabled" style={{ fontSize: 50 }} />
                <p>Adjuntar archivos en formato PDF, JPG, PNG, JPEG</p>
              </div>
            </label>
          </div>
          {messageFiles && <p style={{ color: "red" }}>{messageFiles}</p>}
          {messageCorrectFiles && (
            <p style={{ color: "black", height: "5px" }}>{messageCorrectFiles}</p>
          )}
        </DialogContent>
        <DialogActions style={{ justifyContent: "space-around" }}>
          <Button
            onClick={() => handleClose()}
            color="primary"
            variant="outlined"
            style={{ color: "#7EBDCE", borderColor: "#E1E1E1" }}
          >
            Cancelar
          </Button>
          <Button
            onClick={() => handleSaveFiles()}
            color="primary"
            autoFocus
            disabled={isLoading}
            style={{ backgroundColor: "#7EBDCE", color: "#ffffff" }}
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
      <Backdrop style={{ zIndex: "9999" }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};
export default RefundUploadFilesModal;
